import React, {FC, useEffect, useContext} from 'react'
import { Link } from 'react-router-dom';
import { Dropdown, Avatar, Layout, Button} from 'antd';
import { UserOutlined, AppstoreOutlined, MenuOutlined } from '@ant-design/icons';
import companyLogo from "../../../../../assets/images/logo/companylogo.png";
import {AuthContext} from "../../../../../context/auth/auth.context";
import AdminProfileMenu from "../../../../../components/Menu/ProfileMenu/ProfileMenu";
import Notification from "../../../../../modules/Common/components/Notification/Notification.controller";
import {CONSTANT_CONFIG} from "../../../../../constants";
import {usePermissionContext} from "../../../../../hooks/context/usePermissionContext";
import {DataContext} from "../../../../../context/data/DataContext";
import LanguageSelector from "../../../../../components/Language/LanguageSelector";
import {useLang} from "../../../../../hooks/useLang";
import MyAppsMenu from "../../../../../components/Menu/MyApps/MyApps";
import useBodyClass from "../../../../../hooks/useBodyClass";
import './Header.style.scss';
import { SECURITY_UI_URL } from '@/constants/config.constant';
import HelpModal from "@/theme/Admin/Common/components/Help/Help.modal";

const Header: FC<any> = props => {
    const { setThemeWrapperClassName } = useBodyClass();
    const { isPermissionLoaded, hasPermission } = usePermissionContext();
    const { t, lang, getLangUrl, getAdminLangUrl, getUserLangUrl } = useLang();
    const { profileImage, user } = useContext(AuthContext);
    const dataContext = useContext(DataContext);

    useEffect(() => {
        setThemeWrapperClassName('admin-theme-wrapper');
    }, []);

    return (
        <Layout.Header id="header" className="app-header hide-in-mobile-app">
            <div className="company-logo">
              <a href={SECURITY_UI_URL} className="company-logo-link">
                <img src={companyLogo} alt="Company Logo" style={{ maxHeight: '30px', marginRight: '10px'}}/>
                <h1 className="d-none d-md-inline-block" style={{fontSize: '14px'}}>Ministry of Science &amp; Technology</h1>
              </a>
            </div>
            <Button id="sidebar-toggler" onClick={() => dataContext.setSidebarVisible()} className="mt-2 px-2" icon={<MenuOutlined />}>Sidebar</Button>
            <div className="header-quick-links">
                <div className="quick-link-item" style={{ lineHeight: '28px' }}>
                  <HelpModal />|
                </div>
                <LanguageSelector />
                <div className="quick-link-item quick-link-item-notification">
                    <Notification />
                </div>
                <div className="quick-link-item quick-link-item-my-apps">
                    <Dropdown overlayClassName="avatar-menu-drop-down" overlay={MyAppsMenu(user, isPermissionLoaded, hasPermission, lang, getLangUrl, getAdminLangUrl)} trigger={['click']} placement="bottomRight">
                        <span className="action account">
                            <Avatar  size={24}  icon={<AppstoreOutlined />} />
                        </span>
                    </Dropdown>
                </div>
                <div className="quick-link-item quick-link-item-avatar-menu">
                    <Dropdown overlayClassName="avatar-menu-drop-down" overlay={AdminProfileMenu(user, isPermissionLoaded, hasPermission, t, lang, getLangUrl, getAdminLangUrl, getUserLangUrl)} trigger={['click']} placement="bottomRight">
                        <span className="action account">
                            { profileImage ? (<Avatar shape="circle" src={CONSTANT_CONFIG.CDN_URL + 'image/' + profileImage} alt="Profile Pic" />) : (<Avatar  size={24}  icon={<UserOutlined />} />)}
                            <span className="name">{props.account ? props.account.name : null}</span>
                        </span>
                    </Dropdown>
                </div>
            </div>
        </Layout.Header>
    );
}

export default React.memo(Header);
